export default (function (event, check) {
  return {
    _isMBTransition: true,
    event: event,
    check: check
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-multi-backend/dist/esm/createTransition.js
// module id = 534
// module chunks = 0